import {
  GET_CHAT_PDULI_AI_FAIL,
  GET_CHAT_PDULI_AI_REQUEST,
  GET_CHAT_PDULI_AI_RESET,
  GET_CHAT_PDULI_AI_SUCCESS,
} from "../constants/ChatPduliAIConstants";

export const km_get_chat_pduli_ai_reducers = (state = { data: {} }, action) => {
  switch (action.type) {
    case GET_CHAT_PDULI_AI_REQUEST:
      return { loading: true };
    case GET_CHAT_PDULI_AI_SUCCESS:
      return { loading: false, data: action.payload, success: true };
    case GET_CHAT_PDULI_AI_FAIL:
      return { loading: false, error: action.payload };
    case GET_CHAT_PDULI_AI_RESET:
      return {};
    default:
      return state;
  }
};
